export { DeployTelapp } from './DeployTelapp';
